import { TextFieldModule } from '@angular/cdk/text-field';
import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Application } from '@models';
import { ApplicationService, NotificationService } from '@services';
import { EndpointValidator } from '@validators';

@Component({
  selector: 'app-application-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    ReactiveFormsModule,
    TextFieldModule,
    RouterModule,

    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
  ],
})
export class ApplicationFormComponent {
  readonly service = inject(ApplicationService);
  readonly notificationService = inject(NotificationService);
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);

  readonly application = signal<Application | null>(this.route.snapshot.data['application'] || null);

  form = new FormGroup({
    name: new FormControl(this.application()?.name || '', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    endpoints: new FormControl(this.application()?.endpoints?.join('\n') || '', {
      nonNullable: true,
      validators: [Validators.required, EndpointValidator],
    }),
    validUntil: new FormControl(this.application()?.validUntil)
  });

  save() {
    if (this.form.pristine || !this.form.valid) {
      return;
    }

    const name = this.form.value.name || '';
    const endpoints = this.form.value.endpoints?.split('\n') || [];
    const validUntil = this.form.value.validUntil || undefined;

    const fn = this.application()?.id
      ? this.service.update(this.application()!.id, name, endpoints, validUntil)
      : this.service.create(name, endpoints, validUntil);

    fn.subscribe({
      next: (result?: Application) => {
        console.log(result);
        this.router.navigate(['token', result?.id || this.application()?.id, 'edit']).finally(() => {
          this.form.markAsPristine();
        });
      },
      error: (err) => {
        this.notificationService.error('Failed to save changes.');
        console.error(err);
      }
    });
  }

  delete() {
    if (!this.application()?.id) {
      return;
    }

    this.service.delete(this.application()!.id).subscribe({
      next: () => {
        this.router.navigate(['token']).finally(() => {
          this.notificationService.success(
            `${this.application()!.name}" deleted successfully.`,
          );
        });
      },
      error: (err) => {
        console.error(err);
        this.notificationService.error(
          `Failed to delete "${this.application()!.name}".`,
        );
      },
    });
  }
}
